import { CommonEnums } from '../../common.enums';

export class Tx_Inst_Property {

    dxMp_Id: number;
    obj_Id: number;
    obj_Cd: string;
    property_Cd: string;
    property_Nm: string;
    property_Val: string;
    srt_Order: number;
    property_Type: string;


    /** forceReConnFlg flag has 'Y' or 'N' values, by default it will be 'N' and if already session exists 
         * for that User, then we have to set 'Y', to login forciabilly.
        */
    forceReConnFlg: string;
    ssoFlg: string;
    flag: string;
    type: string;

    constructor() {
        this.setDefaults()
    }

    setDefaults() {
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.obj_Id = CommonEnums.defaults.LONG_VAL;
        this.forceReConnFlg=CommonEnums.defaults.STRING_EMPTY;
        this.obj_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.property_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.property_Nm = CommonEnums.defaults.STRING_EMPTY;
        this.property_Val = CommonEnums.defaults.STRING_EMPTY;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
        this.ssoFlg=CommonEnums.defaults.STRING_EMPTY;
        this.flag=CommonEnums.defaults.STRING_EMPTY;
        this.type=CommonEnums.defaults.STRING_EMPTY;
        this.property_Type = CommonEnums.defaults.STRING_EMPTY;
    }

    static parse(tx_Inst_PropertyTmp: any): Tx_Inst_Property {
        let tx_Inst_Property: Tx_Inst_Property = new Tx_Inst_Property();
        tx_Inst_Property.copyFrom(tx_Inst_PropertyTmp as Tx_Inst_Property);
        return tx_Inst_Property;
    }

    copy(): Tx_Inst_Property {
        let tx_inst_propertyTmp: Tx_Inst_Property = new Tx_Inst_Property();
        tx_inst_propertyTmp.dxMp_Id = this.dxMp_Id;
        tx_inst_propertyTmp.obj_Id = this.obj_Id;
        tx_inst_propertyTmp.obj_Cd = this.obj_Cd;
        tx_inst_propertyTmp.property_Cd = this.property_Cd;
        tx_inst_propertyTmp.property_Nm = this.property_Nm;
        tx_inst_propertyTmp.property_Val = this.property_Val;
        tx_inst_propertyTmp.srt_Order = this.srt_Order;
        tx_inst_propertyTmp.ssoFlg= this.ssoFlg;
        tx_inst_propertyTmp.forceReConnFlg=this.forceReConnFlg;
        tx_inst_propertyTmp.flag=this.flag;
        tx_inst_propertyTmp.type=this.type;
        tx_inst_propertyTmp.property_Type = this.property_Type;

        return tx_inst_propertyTmp;
    }

    copyFrom(tx_inst_propertyTmp: Tx_Inst_Property): void {
        this.dxMp_Id = tx_inst_propertyTmp.dxMp_Id;
        this.obj_Id = tx_inst_propertyTmp.obj_Id;
        this.obj_Cd = tx_inst_propertyTmp.obj_Cd;
        this.property_Cd = tx_inst_propertyTmp.property_Cd;
        this.property_Nm = tx_inst_propertyTmp.property_Nm;
        this.property_Val = tx_inst_propertyTmp.property_Val;
        this.srt_Order = tx_inst_propertyTmp.srt_Order;
        this.ssoFlg=tx_inst_propertyTmp.ssoFlg;
        this.flag=tx_inst_propertyTmp.flag;
        this.forceReConnFlg=tx_inst_propertyTmp.forceReConnFlg;
        this.type=tx_inst_propertyTmp.type;
        this.property_Type = tx_inst_propertyTmp.property_Type;
    }

    compare(tx_inst_propertyTmp: Tx_Inst_Property): string {
        let tx_inst_propertystring: string = this.toString(false);
        let tx_inst_propertyTmpstring: string = tx_inst_propertyTmp.toString(false);
        if (tx_inst_propertystring != tx_inst_propertyTmpstring) {
            return tx_inst_propertystring + ', ' + tx_inst_propertyTmpstring;
        }
        return '';
    }


    toString(isNotCompare: boolean = true): string { 
        let str:string= "Tx_Inst_Property[ dxMp_Id=" + this.dxMp_Id +
            "obj_Id=" + this.obj_Id +
            ",obj_Cd=" + this.obj_Cd +
            ", property_Cd=" + this.property_Cd +
            ", property_Nm=" +  this.property_Nm +
            ",property_Val=" + this.property_Val +
            ",srt_Order=" + this.srt_Order +
            ",property_Type ="+ this.property_Type;
            if (isNotCompare) {
                str += ", forceReConnFlg=" + this.forceReConnFlg+
                ",ssoFlg =" + this.ssoFlg +
                ",flag =" + this.flag +
                ",type =" + this.type;
               
            }
    
            str += ']';
    
            return str;
        }
    }

